import { render, staticRenderFns } from "./DeliveryNoteItemModal.vue?vue&type=template&id=3587b25d&scoped=true"
import script from "./DeliveryNoteItemModal.vue?vue&type=script&lang=ts"
export * from "./DeliveryNoteItemModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587b25d",
  null
  
)

export default component.exports